import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'react-i18next';

// icon
import { WaterLevelIcon } from '../../../assets/svg/Icon';

import Lists from './lists';

// style
import './styles.css';
import { globalStyle } from '../../../global/style';

const useStyles = makeStyles(globalStyle);

export default function Main() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <Box display="flex" alignItems="center">
            <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
              <WaterLevelIcon style={{ color: 'white' }} />
            </Box>
            <Box p={1}><Typography variant="h6" className={classes.titlePage}>{t('คาดการณ์คลื่น')}</Typography></Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Box mt={1}>
            <Lists />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}
